import { getError } from "@/utils/helpers";
import StatuteMeetingService from "@/services/statute/StatuteMeetingService";

export const namespaced = true;

export const state = {
  mails: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_MAILS(state, mails) {
    state.mails = mails;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getMeetings({ commit }, payload) {
    commit("SET_LOADING", true);

    StatuteMeetingService.getSendMailStatute(payload)
      .then((response) => {
        commit("SET_MAILS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_MAILS", []);
  },
};
export const getters = {
  mails: (state) => {
    return state.mails;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
